import { addDraggingToDragDrops } from "../../Editor/Inputs/Labeling";
import { addOrderingToOrderingInputs } from "../../Editor/Inputs/Ordering";
import { loadPropItem } from "../../Loads/Loads";
import { addExamListeners } from "./ExamListeners";
import { addSubmissionListeners } from "./SubmissionListeners";


export function AbLoads():void{
    addExamListeners();
    addSubmissionListeners()

    // MathJax.typeset();

    const props = $(".prop-load-item")
    
    props.each((ind, obj) => {
        loadPropItem(obj);
    });

    // Load Drag'n'Drops
    addDraggingToDragDrops();
    // Ordering
    addOrderingToOrderingInputs();

}

